export default function Ractive$toHTML () {
	return this.fragment.toString( true );
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/toHTML.js.map
